export default function Footer () {
    return (
        <div className="flex justify-between m-4">
            <div className="big-p">Domenic Marchese</div>
            <div>
                <a href="https://www.linkedin.com/in/domenicmarchese/" target={'_blank'} rel={'noreferrer'} className='p-1'>
                    <i className={`fa-brands fa-linkedin mr-1`}/>
                </a>
                <a href="https://github.com/marchesed" target={'_blank'} rel={'noreferrer'} className='p-1'>
                    <i className={`fa-brands fa-github mr-1`}/>
                </a>
            </div>
        </div>
    )
}